const EMAIL_VERIFY_STORAGE_KEY = "email-verify";
const EMAIL_VERIFY_EXPIRATION_STORAGE_KEY = "email-verify-expiration";
const EMAIL_VERIFY_ACTION_TYPE_STORAGE_KEY = "action-type";
const PENDING_EMAIL_VERIFICATION_PLAN_KEY =
  "pending-email-verification-plan";

export const getPendingEmailVerificationPlan = () => {
  const rawValue = localStorage.getItem(PENDING_EMAIL_VERIFICATION_PLAN_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    localStorage.removeItem(PENDING_EMAIL_VERIFICATION_PLAN_KEY);
    return null;
  }
};

export const setPendingEmailVerificationPlan = (payload) => {
  if (!payload?.planId) {
    localStorage.removeItem(PENDING_EMAIL_VERIFICATION_PLAN_KEY);
    return;
  }

  const sanitizedPayload = {
    planId: payload.planId,
    userId: payload.userId,
    promotionCode: payload.promotionCode || "",
    returnUrl: payload.returnUrl || "",
  };

  localStorage.setItem(
    PENDING_EMAIL_VERIFICATION_PLAN_KEY,
    JSON.stringify(sanitizedPayload),
  );
};

export const clearPendingEmailVerificationPlan = () => {
  localStorage.removeItem(PENDING_EMAIL_VERIFICATION_PLAN_KEY);
};

export const clearEmailVerificationFlowStorage = (
  options = { clearPendingPlan: false },
) => {
  localStorage.removeItem(EMAIL_VERIFY_STORAGE_KEY);
  localStorage.removeItem(EMAIL_VERIFY_EXPIRATION_STORAGE_KEY);
  localStorage.removeItem(EMAIL_VERIFY_ACTION_TYPE_STORAGE_KEY);

  if (options.clearPendingPlan) {
    clearPendingEmailVerificationPlan();
  }
};
